import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { FilterButtonComponent } from 'src/app/components/filter-button/filter-button.component';
import { SlackBlocksModule } from 'src/app/components/slack-blocks/slack-blocks.module';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';

import { MessageAnalyticsPage } from './message-analytics/message-analytics.page';
import { MessagingComponent } from './messaging.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    SharedDirectivesModule,
    NgxDatatableModule,
    SlackBlocksModule,
    NgxTippyModule,
    FilterButtonComponent,
  ],
  declarations: [MessagingComponent, MessageAnalyticsPage],
  exports: [MessagingComponent, MessageAnalyticsPage],
})
export class MessagingModule {}
